













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CodeCard extends Vue {
  get modal() {
    return this.modalState;
  }

  set modal(v) {
    this.modalState = v;
  }
  public modalState = false;
  public color = '';
  @Prop() private name!: string;

  @Prop() private description!: string;

  private colors = [
    'is-primary',
    'is-link',
    'is-info',
    'is-success',
    'is-warning',
    'is-danger',
  ];

  public mounted() {
    this.color = this.randomColor();
  }

  public randomColor() {
    return this.colors[
      Math.floor(Math.random() * Math.floor(this.colors.length))
    ];
  }
}
